jQuery(document).ready(function($) {
    'use strict';

    $('.fabric-select').each(function() {
        $(this).on('click', function() {
            $('.tabs-item-inner').removeClass('selected');
            $(this).closest('.tabs-item-inner').addClass('selected');

            $('.wc-pao-addon .input-text').first().val($(this).attr('data-id'));

            var fabric_image = $(this)
                .closest('.tabs-item-inner')
                .find('.tabs-item-image')
                .attr('data-image');

            $(this)
                .closest('.tabs-wrp')
                .find('.selected_fabric_image')
                .addClass('visible')
                .html('<img src="' + fabric_image + '" alt="Tygval" /><i class="far fa-xmark text-[40px] text-white absolute top-4 right-4"></i>');
            $(this)
                .closest('.tabs-wrp')
                .find('.selected_fabric_name')
                .text($(this).attr('data-id'));

            $(document.body).trigger('sp_flyout/hide');
        });
    });

    $('.woocommerce-tab .tabs-item-image').each(function() {
        $(this).on('click', function() {
            if ($(this).hasClass('focused')) {
                $(this).removeClass('focused');
                $(this).children().remove();
            } else {
                $(this)
                    .addClass('focused')
                    .prepend('<img src=" ' +
                        $(this).attr('data-image') +
                        ' " /><i class="far fa-xmark text-[40px] text-white absolute top-4 right-4"></i>');
            }
        });
    });
});
